import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';

const { FiPhone, FiStar, FiShield, FiClock } = FiIcons;
const { FaWhatsapp } = FaIcons;

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const whatsappUrl = "https://wa.me/447734253236";

  return (
    <section id="home" className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url('https://i.postimg.cc/yY86J38Q/IMG-1358.jpg')` }}>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }} 
            className="text-4xl md:text-6xl font-bold mb-6"
          >
            Professional Aerial & Satellite Services
          </motion.h1>
          
          <motion.p 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, delay: 0.2 }} 
            className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto"
          >
            Over 60 years of experience serving Manchester and surrounding areas
          </motion.p>

          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, delay: 0.4 }} 
            className="flex flex-wrap justify-center gap-4 mb-10"
          >
            <div className="flex items-center gap-2 bg-white bg-opacity-20 px-4 py-2 rounded-lg backdrop-blur-sm">
              <SafeIcon icon={FiStar} className="w-5 h-5 text-yellow-400" />
              <span>1000+ Reviews</span>
            </div>
            <div className="flex items-center gap-2 bg-white bg-opacity-20 px-4 py-2 rounded-lg backdrop-blur-sm">
              <SafeIcon icon={FiShield} className="w-5 h-5 text-green-400" />
              <span>Fully Insured</span>
            </div>
            <div className="flex items-center gap-2 bg-white bg-opacity-20 px-4 py-2 rounded-lg backdrop-blur-sm">
              <SafeIcon icon={FiClock} className="w-5 h-5 text-blue-400" />
              <span>Same Day Service</span>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, delay: 0.6 }} 
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <button 
              onClick={scrollToContact} 
              className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all shadow-xl hover:scale-105"
            >
              Get Free Quote
            </button>
            <a 
              href={whatsappUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all shadow-xl flex items-center justify-center gap-2 hover:scale-105"
            >
              <SafeIcon icon={FaWhatsapp} className="w-6 h-6" />
              WhatsApp Us
            </a>
            <a 
              href="tel:07734253236" 
              className="w-full sm:w-auto bg-white hover:bg-gray-100 text-blue-900 px-8 py-4 rounded-lg text-lg font-bold transition-all shadow-xl flex items-center justify-center gap-2 hover:scale-105"
            >
              <SafeIcon icon={FiPhone} className="w-5 h-5" />
              07734253236
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;